export type AppError = Error & { digest?: string };

export function getErrorStatus(error?: AppError, statusCode: number = 500) {
  const digest = error?.digest ? String(error.digest) : undefined;
  const status = digest ? `${statusCode}.${digest}` : statusCode;
  return status;
}
